import { Container, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

function ArticlesPage() {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* HEADER AREA */}
      <Box
        sx={{
          mb: 4,
          p: 3,
          borderRadius: 4,
          background:
            "linear-gradient(135deg, #2563EB 0%, #7C3AED 100%)",
          color: "white",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SearchIcon />
          Articles
        </Box>
      </Box>

      {/* CONTENT AREA (on remplira étape par étape) */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: 3,
        }}
      >
        {/* Placeholder cards */}
        <Box sx={{ height: 160, bgcolor: "#eee", borderRadius: 3 }} />
        <Box sx={{ height: 160, bgcolor: "#eee", borderRadius: 3 }} />
        <Box sx={{ height: 160, bgcolor: "#eee", borderRadius: 3 }} />
      </Box>
    </Container>
  );
}

export default ArticlesPage;